//#region Imports
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { EnterpriseFormModule } from '@rawlings/enterprise-form';
import { ErrorHandler, NgModule } from '@angular/core';
import { GlobalErrorHandler } from './handlers/global-error-handler';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { LoadingSpinnerInterceptor } from './interceptors/loading-spinner.interceptor';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
//#endregion Imports

@NgModule({
  declarations: [
    LoadingSpinnerComponent
  ],
  imports: [
    EnterpriseFormModule,
    NgxSpinnerModule,
    ReactiveFormsModule
  ],
  exports: [
    LoadingSpinnerComponent
  ],
  providers:[
    LoadingSpinnerService,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingSpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ]
})
export class CoreModule { }
